import PageHero from '../components/PageHero';
import SectionIntro from '../components/SectionIntro';
import ResourceCard from '../components/ResourceCard';
import Button from '../components/Button';
import { blogPosts, homeImages } from '../data/siteData';

export default function BlogPage() {
  return (
    <>
      <PageHero
        eyebrow="Blog"
        title="Insights from BrainTorch™ Bio"
        description="Articles, updates, and resources about STEM education, clinical research training, workforce development, and partnerships."
        image={homeImages.wide}
        compact
      />

      <section className="section shell">
        <SectionIntro
          eyebrow="Latest Insights"
          title="Resources for learners, partners, and clinical research leaders"
          text="This blog page is ready for future articles and announcements. The layout is in place so new posts can be added without changing the site structure."
          align="center"
        />
        <div className="card-grid card-grid--three top-gap-lg">
          {blogPosts.map((item) => (
            <ResourceCard key={item.title} item={item} />
          ))}
        </div>
      </section>

      <section className="section shell section--tight-top">
        <div className="cta-band">
          <div>
            <h2>Have a topic you want to discuss?</h2>
            <p>Connect with BrainTorch™ Bio about programs, partnerships, or clinical research workforce development.</p>
          </div>
          <Button to="/contact#contact-form" variant="teal">Contact Us</Button>
        </div>
      </section>
    </>
  );
}
